module.exports = __webpack_public_path__ + "img/guide_logo.1cb99111.png";